<template>
    <v-dialog max-width="600px" v-model="dialog">
        <!-- <v-btn flat slot="activator" color="primary">Add a quote or Excerpt</v-btn> -->
        <v-btn slot="activator" class="mx-2" flat fab>
        <v-icon dark>add</v-icon>
        </v-btn>
        <v-card>
            <v-card-title>
                <span class="headline font-weight-bold">Add a Product Feature:</span> 
                <!-- <v-alert
                :value="true"
                color="primary"
                icon="info"
                class="caption text-lg-justify"
                outline>
                You have seleect
              </v-alert>  -->
            </v-card-title>

            <v-card-text>
                <v-form class="px-3" ref="form">
                    <v-textarea outline :label="productfeaturetitleLabeltext" v-model="productfeaturetitletext" :hint="productfeaturetitleHint" :rules="textInputRules"></v-textarea>
                    <v-textarea outline :label="productfeaturedescriptionLabeltext" v-model="productfeaturedescriptiontext" :hint="productfeaturedescriptionHint" :rules="textInputRules"></v-textarea>
                    
                     
                    <v-radio-group v-model="moscowposition" label="This feature is a:" :mandatory="true" row>
                        <v-radio :label="moscowvariables[0]" value="must_have"></v-radio>
                        <v-radio :label="moscowvariables[1]" value="should_have"></v-radio>
                        <v-radio :label="moscowvariables[2]" value="could_have"></v-radio>
                        <v-radio :label="moscowvariables[3]" value="wouldnot_have"></v-radio>
                        </v-radio-group> 

                    <v-checkbox v-model="featureavailableinacompetingproduct" :label="featureavailableinacompetingproductLabeltext"></v-checkbox> 

                    <!-- <v-btn flat color="primary" @click="submit" :loading="loading">Add Product Feature</v-btn>  -->
                    <v-btn flat color="primary" @click="dummySubmit" :loading="loading">Add Product Feature</v-btn> 
                    <!-- <v-btn flat to="/bifdashboard" color="primary" class="mx-2 mt-3" :loading="loading">Add Story</v-btn> -->
                    <v-btn flat @click="dialog = false">Cancel</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import db from '../fb'
import gvars from '../globalvariables'

export default {
    name: '',
    data() {
        return{
            productfeaturetitletext: 'Export tasks to csv', 
            productfeaturetitleLabeltext: 'Provide a title to this feature', 
            productfeaturetitleHint: 'It is ideal to keep the feature title concise and brief, at the same time, it should clearly explain what the feature offers to the end user.', 
            productfeaturedescriptiontext: 'This features exports all tasks entered into the system to a csv format, which is a common format to export and import data into systems.', 
            productfeaturedescriptionLabeltext: 'How would you describe this feature (briefly)', 
            productfeaturedescriptionHint: 'Adding a description can help designers and developers understand the feature better and therefore subsequently provide a better outcome.', 
            featureavailableinacompetingproduct: true,
            featureavailableinacompetingproductLabeltext: 'This feature is currently offered by a competing product',
            moscowposition: 'wouldnot_have',
            moscowvariables: ['Must have', 'Should have', 'Could have', 'Would not have'],
            textInputRules: [
                    v => !!v || 'This field is required',
                    v => v.length >= 3 || 'Minimum length is 3 characters'
                ],
            loading: false,
            dialog: false
        }
    },
    methods: {
        submit() {

             if(this.$refs.form.validate()) {
            //console.log(this.nameofthesolution, this.briefdescriptionofthesolution)
            this.loading = true;
             

            //details = {}

            const productfeature = {
                productfeaturetitletext: this.productfeaturetitletext,
                productfeaturedescriptiontext: this.productfeaturedescriptiontext,
                moscowposition: this.moscowposition,
                featureavailableinacompetingproduct: this.featureavailableinacompetingproduct
            }

            //details['prefs'] = firstprefdetails;
 

            //
            //xuWrU7qOYXxLjL97QoCe

        var dbref = db.collection('projects').doc(this.getProjectID()).collection('productfeatures');

        dbref.add(productfeature).then(() =>{
            //console.log('Collection quotes created')
                      this.loading = false;
          this.dialog = false;
          this.$emit('featureadded')
        });


    //     db.collection('projects').doc('Yx3r6dHUeFFdGvY6Acvy').collection('quotesregardingfirstprefsolutionconcept').update(quote).then(() => {
    //       //console.log("added to db!", docRef.id)
    //       this.loading = false;
    //       this.dialog = false;
    //       this.$emit('quoteconfirmed')
    //    });

             }
        },
        dummySubmit(){
            this.loading = false;
          this.dialog = false;

        },
    getProjectID(){
      return gvars.PROJECTID;
    } 
    }
}
</script>
